import React, { useContext, useState, useEffect } from 'react';
import { ShopperContext } from '../context/shopper';
import { HeadingBuilder } from './HeadingBuilder';
import * as Constants from '../constants';
import { useTranslation } from "react-i18next";    

export const StripeCircleBuyButton = ({ whichPlan }) => {
  const {
    signedIn, shopper, clientReferenceId,
    stripeIsLive
  } = useContext(ShopperContext);
  console.log('scbb whichPlan', whichPlan);
  console.log('scbb clientReferenceId', clientReferenceId);
  const { t } = useTranslation();

  const pub_key_test    = "pk_test_51RCWp1PsnwguDT3t8KE95sUObse1RtYzOJJYzHeaOylBCZdwbVKosvLbHZBIhjTrGvZMsMNIWhXZngjGBKriUs3o00rBA61gP4";
  const publishable_key = "pk_live_51NSO67LAmhXuStLF0lOHA6JgSIsbZaeQ2L3vv5HVW18Rrh317TjLjlto6oaXEoqOyoU3ggW4CHVWIVuDwJGOxmRf00r1gTMHAX"

  // function lookup_plan ({
  //   plan,
  // }) {
  function lookup_plan (
    plan,
  ) {
    console.log('scbb plan', plan);
    switch (plan) {
      case  "weekly3us200": return {
          // "product_name_test": "Test - Up to 3 shoppers",
          "buy_button_id_test": "buy_btn_1ROVJCPsnwguDT3tKkr3bsVo",
          // "product_name": "Up to 3 shoppers",
          "buy_button_id": "buy_btn_1OjRzDLAmhXuStLF4Iru69r0",
      };
      case  "monthly3us300": return {
          // "product_name_test": "Test - Up to 3 shoppers",
          "buy_button_id_test": "buy_btn_1ROVs0PsnwguDT3t2w78NtDZ",
          // "product_name": "Up to 3 shoppers",
          "buy_button_id": "buy_btn_1OfcE3LAmhXuStLFer1T4JZ3",
      };
      case  "biannual3us1300": return {
          // "product_name_test": "Test - Up to 3 shoppers",
          "buy_button_id_test": "buy_btn_1ROXCjPsnwguDT3tXmA6Kucs",
          // "product_name": "Up to 3 shoppers",
          "buy_button_id": "buy_btn_1OiI1hLAmhXuStLFxAlJRgdY",
      };
      case  "weekly5us325": return {
          // "product_name_test": "Test - Up to 5 shoppers",
          "buy_button_id_test": "buy_btn_1RQF2LPsnwguDT3tHQe6grLU",
          // "product_name": "Up to 5 shoppers",
          "buy_button_id": "buy_btn_1RQEbcLAmhXuStLFesOTH79f",
      };
      case  "monthly5us500": return {
          // "product_name_test": "Test - Up to 5 shoppers",
          "buy_button_id_test": "buy_btn_1ROXFGPsnwguDT3tOTEBwxpy",
          // "product_name": "Up to 5 shoppers",
          "buy_button_id": "buy_btn_1Ofc6rLAmhXuStLFBiBUrcu1",
      };
      case  "biannual5us1900": return {
          // "product_name_test": "Test - Up to 5 shoppers",
          "buy_button_id_test": "buy_btn_1ROVUXPsnwguDT3tL9fiwST2",
          // "product_name": "Up to 5 shoppers",
          "buy_button_id": "buy_btn_1OiiWiLAmhXuStLF6vITC0As",
      };
      case  "weekly8us525": return {
          // "product_name_test": "Test - Up to 8 shoppers",
          "buy_button_id_test": "buy_btn_1RQEqLPsnwguDT3tIm1F3vJN",
          // "product_name": "Up to 8 shoppers",
          "buy_button_id": "buy_btn_1RQELBLAmhXuStLF1bWvCROM",
      };
      case  "monthly8us800": return {
          // "product_name_test": "Test - Up to 8 shoppers",
          "buy_button_id_test": "buy_btn_1ROXJCPsnwguDT3tpePieVBq",
          // "product_name": "Up to 8 shoppers",
          "buy_button_id": "buy_btn_1OesGSLAmhXuStLFAh0H0ZUb",
      };
      case  "biannual8us2900": return {
          // "product_name_test": "Test - Up to 8 shoppers",
          "buy_button_id_test": "buy_btn_1ROXKHPsnwguDT3tLF3ZMb2L",
          // "product_name": "Up to 8 shoppers",
          "buy_button_id": "buy_btn_1Ofc2ULAmhXuStLFTSFsrCpS",
      };
      default:  return {
          "buy_button_id": "",
          "publishable_key": "",
      };
    }
  };
  const stripeParams = lookup_plan(whichPlan)
  console.log('scbb sParams', stripeParams);
  console.log('scbb sParams.buy_button_id', stripeParams.buy_button_id);
  console.log('scbb sParams.buy_button_id_test', stripeParams.buy_button_id_test);
  console.log('scbb cust_email', shopper.email);

  // Get 'client_secret' from backend as a pointer to Stripe Customer details.
  // Save as a state variable to assign later to 'customer-session-client-secret'
  // Each 'Buy' button gets its own 'client_secret'.
  const [clientSecret, setClientSecret] = useState("");

  useEffect( () => {
    (async () => {
      await fetch('/funds/session')
        .then(res => res.json())
        .then(data => {
          if (data.errors) {
            // TODO: do something with the error(s)
            console.log(data.errors);
          } else {
            setClientSecret(data.client_secret)
            // Stripe will honor 'clientSecret' for 30 minutes.
            // 'data.client_secret' is based on stripe_customer_id
          }
        })
    })()
  }, [])

  return (
   <>
    <div>
      {
        <stripe-buy-button
          buy-button-id={
            stripeIsLive
              ? stripeParams.buy_button_id
              : stripeParams.buy_button_id_test
          }

          publishable-key={
            stripeIsLive
              ? publishable_key
              : pub_key_test
          }

          client-reference-id={clientReferenceId}
          customer-session-client-secret={clientSecret}
        >
        </stripe-buy-button>
      }
    </div>
   </>
  );
};

export default StripeCircleBuyButton;
